import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const SaintLucia: Country = {
    identifier: "SaintLucia",
    name: "Saint Lucia",
    countryCode: "LC",
    group: CountryGroup.CENTRAL_AMERICA,
    isUNMember: true,
    flag: "🇱🇨",
    svgPath: "m 303.99375,424.0054 -0.158,0.3 -0.307,-0.188 -0.034,-0.237 0.027,-0.143 0.187,-0.274 0.146,-0.178 0.103,-0.059 0.06,0.236 z",
}
